<template>
    <label class="checkBox customCheckBox" :class="{ checked: isChecked ,disable:isDisable}" @click="onCheckBoxChanged">
        <span class="customCheckBoxItem"></span>
        <span class="customCheckBoxTitle">{{title}}</span>
    </label>
</template>

<script>
export default {
    name: "RcclCheckBox",
    props: {
        defaultChecked: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        customItem: {
            type: String
        },
        defaultDisable: {
            type: Boolean,
            default:false
        },
    },
    data () {
        return {
            isChecked: false,
            isDisable:false
        }
    },
    beforeMount () {
        this.isChecked = this.defaultChecked
        this.isDisable = this.defaultDisable
    },
    methods: {
        onCheckBoxChanged () {
            if(!this.isDisable){
                this.isChecked = !this.isChecked
                this.$emit('onChanged', this.isChecked, this.customItem)
            }
        }
    },
    watch: {
        defaultChecked (newValue) {
            this.isChecked = newValue
        },
        defaultDisable(newValue){
            this.isDisable = newValue
        }
    }
}
</script>

<style lang="less" scoped>
.customCheckBox {
    vertical-align: middle;
    margin-bottom: 0px;
    .customCheckBoxItem {
        width: 18px;
        height: 18px;
        border: 1px solid #d3dadd;
        border-radius: 2px;
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;
    }
    .customCheckBoxTitle {
        margin-left: 5px;
        vertical-align: middle;
    }
}

.customCheckBox.checked {
    .customCheckBoxItem {
        background: url(https://resource.rcclchina.com.cn/tui2/list/icon-checkBox-checked.png) no-repeat center;
        border-color: #006ab9;
    }
}
.customCheckBox.disable {
    .customCheckBoxItem {
        background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png) no-repeat center;
        border-color: #a6aeb1;
    }
}
</style>